import {
  Component,
  OnInit,
  Input,
  Renderer2,
  EventEmitter,
  Output,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DispatchBookingComponent } from '@shared/components/dispatch-action/booking/booking.component';
import { OfferComponent } from '@shared/components/dispatch-action/offer/offer.component';
import { TempBookingComponent } from '@shared/components/temp-booking/temp-booking.component';
import { DetailsPrestationComponent } from '@components/zalona-prestations/services-details/details-prestation/details-prestation.component';
import IPrestation from '@models/prestation.model';
import { createChip, manageSlug } from '@shared/functions';

@Component({
  selector: 'app-services-details',
  templateUrl: './services-details.component.html',
  styleUrls: ['./services-details.component.scss'],
})
export class ServicesDetailsComponent implements OnInit {
  @Input() prestation: IPrestation;
  @Input() detailsIdUrl: string;
  @Output() detailsIdUrlChange: EventEmitter<string> =
    new EventEmitter<string>();
  private slugs: any[] = null;

  public description: string = '';
  constructor(
    public dialog: MatDialog,
    private renderer: Renderer2,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private location: Location
  ) {
    this.slugs = manageSlug(this.location.path(), 'prestations');
  }

  ngOnInit(): void {
    if (this.prestation.description) {
      this.description = this.prestation.description.substring(0, 120) + ' ...';
    }
  }
  ngOnDestroy() {
    this.detailsIdUrlChange.emit(null);
  }

  ngAfterViewInit(): void {
    if (
      this.detailsIdUrl !== null &&
      this.detailsIdUrl === this.prestation.id
    ) {
      if (this.slugs[1] && this.slugs[1].type === 'details') {
        this.openDetails(this.prestation);
      }

      if (this.slugs[1] && this.slugs[1].type === 'offrir') {
        this.offer(this.prestation);
      }
    }
  }

  reservation(event, prestation: IPrestation) {
    createChip(event, '.containerBaskBooking', this.renderer).then((e) => {
      this.dialog.open(DispatchBookingComponent, {
        data: {
          prestation: prestation,
          type: 'BOOKING',
        },
        panelClass: 'zalona-modalbox',
        width: '600px',
      });
    });
  }

  contactUs(prestation: IPrestation) {
    this.dialog.open(TempBookingComponent, {
      panelClass: 'zalona-modalbox',
      width: '400px',
      data: {
        element: prestation,
        type: 'CURE',
      },
    });
  }

  manageUrl(prestation: IPrestation, active: boolean, type: string) {
    if (this.slugs !== null && this.slugs.length > 0) {
      const firstFragment = this.slugs[0].path;
      if (active === true) {
        const id = prestation.id;
        const name = prestation.name.trim().replace(/\s/g, '-');
        this.location.replaceState(
          `prestations/${firstFragment}/${type}-${id}-${name}`
        );
      } else {
        this.location.replaceState(`prestations/${firstFragment}`);
      }
    }
  }

  openDetails(prestation: IPrestation) {
    this.manageUrl(prestation, true, 'details');
    this.dialog
      .open(DetailsPrestationComponent, {
        data: {
          prestation: prestation,
        },
        panelClass: 'zalona-modalbox',
        width: '600px',
      })
      .afterClosed()
      .subscribe(() => {
        this.manageUrl(null, false, '');
      });
  }

  offer(prestation: IPrestation) {
    this.manageUrl(prestation, true, 'offrir');
    this.dialog
      .open(OfferComponent, {
        data: {
          prestation: prestation,
          type: 'SERVICE',
        },
        panelClass: 'zalona-modalbox',
      })
      .afterClosed()
      .subscribe(() => {
        this.manageUrl(null, false, '');
      });
  }
}
